const API_URL = process.env.REACT_APP_API_URL;

// Admin Management
const EMAIL_NOTIFICATION_SERVICE = API_URL + "/EmailNotificationService/";
const EMAIL_NOTIFICATION_EVENT = API_URL + "/EmailNotificationEvent/";
const EMAIL_NOTIFICATION_USER = API_URL + "/EmailNotificationUser/";
const EMAIL_NOTIFICATION_USERSELECTION = API_URL + "/EmailNotificationUserSelection/";
const EMAIL_NOTIFICATION_EXPORT = API_URL + "/EmailExport/";

export const EmailNotificationApiUrl = {

    // Admin Management
    EMAIL_NOTIFICATION_SERVICE_GET_LIST: EMAIL_NOTIFICATION_SERVICE + "GetList",
    EMAIL_NOTIFICATION_EVENT_UPDATE: EMAIL_NOTIFICATION_EVENT + "UpdateEmailEvent?id=",
    EMAIL_NOTIFICATION_EVENT_GET: EMAIL_NOTIFICATION_EVENT + "GetEmailEvent?id=",
    EMAIL_NOTIFICATION_USER_GET_UNSELECTEDINTERNALUSER: EMAIL_NOTIFICATION_USERSELECTION + "GetUnselectedInternalUsers",
    EMAIL_NOTIFICATION_USER_GET_SELECTEDUSERS: EMAIL_NOTIFICATION_USERSELECTION + "GetPagedSelectedUsers",


    EMAIL_NOTIFICATION_USER_DELETE: EMAIL_NOTIFICATION_USER + "DeleteEmailNotificationUser?id=",
    EMAIL_NOTIFICATION_USER_CREATE: EMAIL_NOTIFICATION_USER + "CreateEmailNotificationUser",

    EMAIL_NOTIFICATION_EXPORT: EMAIL_NOTIFICATION_EXPORT,

    // User Settings
    EMAIL_NOTIFICATION_USERS_BY_SERVICES: EMAIL_NOTIFICATION_USER + "GetEmailNotificationUsersByService",
    EMAIL_NOTIFICATION_USERS_UPDATE_FREQUENCIES: EMAIL_NOTIFICATION_USER + "UpdateEmailNotificationUserFrequencies",

    // Selected VSS Clients
    EMAIL_NOTIFICATION_FULL_SELECTED_VSS_CLIENT_GET: EMAIL_NOTIFICATION_USER + "GetAllVssClientEmailNotification",
    EMAIL_NOTIFICATION_SELECTED_VSS_CLIENTS_DELETE: EMAIL_NOTIFICATION_USER + "DeleteSelectedVssClientsEmailNotification",
    EMAIL_NOTIFICATION_SELECTED_VSS_CLIENT_SAVE: EMAIL_NOTIFICATION_USER + "SaveSelectedVSSClientsEmailNotification",
}